const indicatorClasses =
    'bg-primary-surface border border-primary-surface rounded-[calc(var(--spacing)*2.5)] ' +
    'shadow-[0_1px_0_rgba(16,24,40,0.04),0_2px_4px_rgba(16,24,40,0.06)] ' +
    'text-sm leading-[1.55] text-heading max-w-full break-words ' +
    'flex items-center gap-1.5 py-3.5 px-4.5 w-fit';

const dotClasses = 'w-2 h-2 rounded-full bg-disabled animate-typing-bounce';

const DOT_DELAYS = ['0s', '0.2s', '0.4s'];

const ChatTypingIndicator = () => (
    <div className={indicatorClasses}>
        {DOT_DELAYS.map((delay) => (
            <span key={delay} className={dotClasses} style={{ animationDelay: delay }} />
        ))}
    </div>
);

export default ChatTypingIndicator;
